import ReactDOM from 'react-dom';

import SubscribeForm from './SubscribeForm';

const Subscribe = (props) => {
  const { node } = props;
  return ReactDOM.createPortal(
    <SubscribeForm
      form={`Subscribe${props.index}`}
      hasNameFields={props.hasNameFields}
      hasZipCode={props.hasZipCode}
    />,
    node
  );
};

export default Subscribe;
